import bosOutlineDone from '../../assets/common/bos-outline-done.svg';
import { AppContent } from '../AppContent';

const submitYourRegistration: AppContent['submitYourRegistration'] = {
  submitYourRegistrationContent: [
    {
      serviceName: 'Business Internet Banking',
      header: 'Submit your registration',
      verificationSuccess: 'Verification complete',
      haveEverything:
        'We now have everything we need and you can submit your registration.',
      submitRegistration: 'Submit registration',
      imageSrc: bosOutlineDone,
      imageAltText: 'Submit your registration',
      submitBtnHref: '/thank-you',
      technicalErrorPageHref: '/technical-error',
    },
  ],
};

export default submitYourRegistration;
